import React, { FC } from "react"
import { Link } from 'react-router-dom'
import { Menu } from 'antd'
import Icon, { BarChartOutlined, CrownOutlined, GlobalOutlined, HistoryOutlined, HomeOutlined, SketchOutlined, TrophyOutlined, TwitterOutlined, YoutubeOutlined, SkinOutlined, VideoCameraOutlined } from "@ant-design/icons"
import { ReactComponent as DiscordSvg } from '../../util/icons/discord.svg'
import { ReactComponent as TwitchSvg } from '../../util/icons/twitch.svg'

const { Item, ItemGroup } = Menu

export interface MenuComponentProps {
    completed: boolean;
    bonus: boolean;
}

export const MenuComponent: FC<MenuComponentProps> = (props) => {
    return (
        <Menu>
            <ItemGroup title="Current Tournament" key={"currentTourney"}>
                <Item key="0" icon={<HomeOutlined />}>
                    Home
                    <Link to="/" />
                </Item>
                <Item key="5" icon={<VideoCameraOutlined />}>
                    Stream
                    <Link to="/stream" />
                </Item>
                {props.completed && <Item key="1" icon={<BarChartOutlined />}>
                    Miscellaneous Stats
                    <Link to="/miscellaneous" />
                </Item>}
                <Item key="2" icon={<TrophyOutlined />}>
                    Leaderboards
                    <Link to="/leaderboards" />
                </Item>
                {props.completed &&
                    <Item key="3" icon={<CrownOutlined />}>
                        Awards
                        <Link to="/awards" />
                    </Item>
                }
                {props.bonus &&
                    <Item key="4" icon={<SketchOutlined />}>
                        Bonus
                        <Link to="/bonus" />
                    </Item>
                }
            </ItemGroup>
            <ItemGroup title="Past Tournaments" key="pastTourney">
                <Item key="1-1" icon={<HistoryOutlined />}>
                    Past Tournaments
                    <Link to="/history" />
                </Item>
            </ItemGroup>
            {/* TODO: SVG Icons with hover capabilities to alter color */}
            <ItemGroup title="About" key={"about"}>
                <Item key="about-discord" icon={<Icon component={DiscordSvg} />} >
                    <a href="https://discord.gg/xdaaKCd" target="_blank" rel="noopener noreferrer">Discord</a>
                </Item>
                <Item key="about-twitch" icon={<Icon component={TwitchSvg} />} >
                    <a href="https://twitch.tv/ObiWannCoyote" target="_blank" rel="noopener noreferrer">Twitch</a>
                </Item>
                <Item key="about-twitter" icon={<TwitterOutlined />} >
                    <a href="https://twitter.com/ObiWannCoyote" target="_blank" rel="noopener noreferrer">Twitter</a>
                </Item>
                <Item key="about-youtube" icon={<YoutubeOutlined />}>
                    <a href="https://www.youtube.com/c/ObiWannCoyote" target="_blank" rel="noopener noreferrer">YouTube</a>
                </Item>
                <Item key="about-website" icon={<GlobalOutlined />}>
                    <a href="http://obiwanncoyote.com/" target="_blank" rel="noopener noreferrer">ObiWannCoyote</a>
                </Item>
                <Item key="about-Merch" icon={<SkinOutlined />}>
                    <a href="https://store.streamelements.com/obiwanncoyote" target="_blank" rel="noopener noreferrer">Merch</a>
                </Item>
            </ItemGroup>
        </Menu>
    )
}